import { render, staticRenderFns } from "./DeleteResourceAuditFlow.vue?vue&type=template&id=b70cb3b8&scoped=true"
import script from "./DeleteResourceAuditFlow.vue?vue&type=script&lang=js"
export * from "./DeleteResourceAuditFlow.vue?vue&type=script&lang=js"
import style0 from "./DeleteResourceAuditFlow.vue?vue&type=style&index=0&id=b70cb3b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70cb3b8",
  null
  
)

export default component.exports